import interpolateComponents from '@automattic/interpolate-components';
import { useLocation } from 'react-router-dom';
import { sprintf } from 'sprintf-js';

import { ApiUser } from 'api/userEnvironment/types/ApiUserEnvironment';
import { StyledNativeLinkWithRef } from 'components/Link/StyledNativeLinkWithRef';
import { Text } from 'components/Text/Text';
import { ClientOnly } from 'containers/ClientOnly';
import { ApiOrg } from 'modules/listing/api/org/types/ApiOrg';
import { useUserEnvironment } from 'store/hooks/useUserEnvironment';
import { legacySpace } from 'theme/theme';
import { showModal } from 'zustand-stores/modalStore';

function userAdminRequest(
  user: ApiUser | null | undefined,
  org: ApiOrg,
): boolean {
  return Boolean(
    user?.orgAdminRequests &&
      user.orgAdminRequests.some((o) => o.orgId === org.id),
  );
}

type Props = {
  org: ApiOrg;
  orgOwner: boolean;
};

export function ViewOrgPageSidebarDetails({ org, orgOwner }: Props) {
  const location = useLocation();
  const { user } = useUserEnvironment();
  const openAdminRequest = userAdminRequest(user, org);

  return (
    <>
      {!orgOwner && !openAdminRequest && (
        <ClientOnly>
          <Text color="lightContentGrey" mb={legacySpace[3]}>
            {sprintf(getText('Do you work for %(orgName)s?'), {
              orgName: org.name,
            })}
          </Text>
          <Text mb={legacySpace[3]}>
            {interpolateComponents({
              mixedString: getText(
                "{{link}}Request administrator access{{/link}} to start posting jobs and other opportunities from this organization's profile",
              ),
              components: {
                link: (
                  <StyledNativeLinkWithRef
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      return user
                        ? showModal('ADMIN_REQUEST', {
                            objectId: org.id,
                            objectName: org.name,
                          })
                        : showModal('EMAIL_SIGNUP', {
                            title:
                              /* TRANSLATORS: title of dialog to request to be admin of org */
                              getText('Request to Become an Administrator'),
                            redirectTo: `${location.pathname}?admin-request=true`,
                          });
                    }}
                  />
                ),
              },
            })}
          </Text>
        </ClientOnly>
      )}
      {openAdminRequest && (
        <ClientOnly>
          <Text color="lightContentGrey" mb={legacySpace[3]}>
            {sprintf(
              getText(
                'You have a pending request to become an administrator for %(orgName)s',
              ),
              {
                orgName: org.name,
              },
            )}
          </Text>
        </ClientOnly>
      )}
    </>
  );
}
